import { useEffect, useRef, useState } from 'react';

function WhatsNew({ entries, onClose }) {
    const [step, setStep] = useState( 0 );
    const primaryButton = useRef( null );
    const entry = entries[ step ];
    const isFirst = step === 0;
    const isLast = step === entries.length - 1;

    const goNext = () => setStep( ( current ) => Math.min( current + 1, entries.length - 1 ) );
    const goBack = () => setStep( ( current ) => Math.max( current - 1, 0 ) );

    useEffect( () => {
        primaryButton.current?.focus();
    }, [ step ] );

    useEffect( () => {
        const onKeyDown = ( event ) => {
            if ( event.key === 'Escape' ) {
                onClose();
            } else if ( event.key === 'ArrowRight' ) {
                goNext();
            } else if ( event.key === 'ArrowLeft' ) {
                goBack();
            }
        };

        document.addEventListener( 'keydown', onKeyDown );

        return () => document.removeEventListener( 'keydown', onKeyDown );
    } );

    return (
        <div
            className = "whats-new-overlay"
            onClick = { onClose }
        >
            <div
                className = "whats-new-content"
                role = "dialog"
                aria-modal = "true"
                aria-labelledby = "whats-new-title"
                onClick = { ( event ) => event.stopPropagation() }
            >
                <button
                    type = "button"
                    className = "whats-new-close"
                    aria-label = "Stäng"
                    onClick = { onClose }
                >
                    ×
                </button>
                <div className = "whats-new-image-frame">
                    <img
                        key = { entry.id }
                        className = "whats-new-image"
                        src = { entry.image }
                        alt = ""
                    />
                </div>
                <div className = "whats-new-body">
                    <span className = "whats-new-eyebrow">Nytt i L0LC4tor</span>
                    <h2
                        id = "whats-new-title"
                        className = "whats-new-title"
                    >
                        { entry.title }
                    </h2>
                    <p className = "whats-new-text">{ entry.description }</p>
                </div>
                <div className = "whats-new-footer">
                    { entries.length > 1 ? (
                        <div
                            className = "whats-new-dots"
                            role = "group"
                            aria-label = { `Steg ${ step + 1 } av ${ entries.length }` }
                        >
                            { entries.map( ( item, index ) => (
                                <button
                                    type = "button"
                                    key = { item.id }
                                    className = { `whats-new-dot${ index === step ? ' whats-new-dot-active' : '' }` }
                                    aria-label = { `Gå till steg ${ index + 1 }` }
                                    aria-current = { index === step ? 'step' : undefined }
                                    onClick = { () => setStep( index ) }
                                />
                            ) ) }
                        </div>
                    ) : <span /> }
                    <div className = "whats-new-actions">
                        { !isLast && (
                            <button
                                type = "button"
                                className = "whats-new-secondary"
                                onClick = { onClose }
                            >
                                Hoppa över
                            </button>
                        ) }
                        { !isFirst && (
                            <button
                                type = "button"
                                className = "whats-new-secondary"
                                onClick = { goBack }
                            >
                                Tillbaka
                            </button>
                        ) }
                        <button
                            type = "button"
                            className = "whats-new-primary"
                            onClick = { isLast ? onClose : goNext }
                            ref = { primaryButton }
                        >
                            { isLast ? 'Klart' : 'Nästa' }
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default WhatsNew;
